// source: witbooking/backoffice/extra/v1/extra_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.BookableRef', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.BookableRef.RefTypeCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.BookableRefExtra', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.BookableRefInventory', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.BookableRefInventoryList', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.BookableRefList', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.BookableRefPromo', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.CreateExtraRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.CreateExtraResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DateWindow', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DateWindowPeriod', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DeleteExtraRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DeleteExtraResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.Extra', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.ExtraList', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.FilterExtra', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.FilterExtraUse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.FilterExtrasRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.FilterExtrasResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.GetExtraRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.GetExtraResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.GetExtrasRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.GetExtrasResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.GuestType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.InventoryTickerList', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.LockType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.MaxStayDuration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.MinStayDuration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.Multimedia', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.Rate', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.Rate.RateTypeCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RateConstant', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RateFormula', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RateOwn', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RatePercentage', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RateShared', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.ReorderExtraRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.ReorderExtraResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionAvailability', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionBlockage', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionCode', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionMaxStay', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionMinNotice', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionMinStay', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionValue', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionValue.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionValueConstant', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionValueOwn', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.RestrictionValueShared', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.Restrictions', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.SimpleDuration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.StayDaysFilterType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.Translation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.Type', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.UnlockCode', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.UnlockCodes', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.UpdateExtraRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.UpdateExtraResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.extra.v1.Variant', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.GetExtrasRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.GetExtrasRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.GetExtrasRequest.displayName = 'proto.witbooking.backoffice.extra.v1.GetExtrasRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.GetExtrasResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.GetExtrasResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.GetExtrasResponse.displayName = 'proto.witbooking.backoffice.extra.v1.GetExtrasResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.GetExtraRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.GetExtraRequest.displayName = 'proto.witbooking.backoffice.extra.v1.GetExtraRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.GetExtraResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.GetExtraResponse.displayName = 'proto.witbooking.backoffice.extra.v1.GetExtraResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.CreateExtraRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.CreateExtraRequest.displayName = 'proto.witbooking.backoffice.extra.v1.CreateExtraRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.CreateExtraResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.CreateExtraResponse.displayName = 'proto.witbooking.backoffice.extra.v1.CreateExtraResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.UpdateExtraRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.displayName = 'proto.witbooking.backoffice.extra.v1.UpdateExtraRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.UpdateExtraResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.displayName = 'proto.witbooking.backoffice.extra.v1.UpdateExtraResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.displayName = 'proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.displayName = 'proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DeleteExtraRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.displayName = 'proto.witbooking.backoffice.extra.v1.DeleteExtraRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DeleteExtraResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.displayName = 'proto.witbooking.backoffice.extra.v1.DeleteExtraResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.ReorderExtraRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.displayName = 'proto.witbooking.backoffice.extra.v1.ReorderExtraRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.ReorderExtraResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.displayName = 'proto.witbooking.backoffice.extra.v1.ReorderExtraResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.displayName = 'proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.displayName = 'proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.ExtraList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.ExtraList.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.ExtraList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.ExtraList.displayName = 'proto.witbooking.backoffice.extra.v1.ExtraList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.FilterExtrasRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.displayName = 'proto.witbooking.backoffice.extra.v1.FilterExtrasRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.FilterExtra = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.FilterExtra, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.FilterExtra.displayName = 'proto.witbooking.backoffice.extra.v1.FilterExtra';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.FilterExtrasResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.displayName = 'proto.witbooking.backoffice.extra.v1.FilterExtrasResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.displayName = 'proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.displayName = 'proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.displayName = 'proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.displayName = 'proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.displayName = 'proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.displayName = 'proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.displayName = 'proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.displayName = 'proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.displayName = 'proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.Extra = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.Extra.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.Extra, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.Extra.displayName = 'proto.witbooking.backoffice.extra.v1.Extra';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.BookableRefList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.BookableRefList.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.BookableRefList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.BookableRefList.displayName = 'proto.witbooking.backoffice.extra.v1.BookableRefList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.BookableRefInventoryList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.displayName = 'proto.witbooking.backoffice.extra.v1.BookableRefInventoryList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.BookableRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.extra.v1.BookableRef.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.BookableRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.BookableRef.displayName = 'proto.witbooking.backoffice.extra.v1.BookableRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.BookableRefInventory.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.BookableRefInventory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.BookableRefInventory.displayName = 'proto.witbooking.backoffice.extra.v1.BookableRefInventory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.BookableRefPromo.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.BookableRefPromo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.BookableRefPromo.displayName = 'proto.witbooking.backoffice.extra.v1.BookableRefPromo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.BookableRefExtra.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.BookableRefExtra, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.BookableRefExtra.displayName = 'proto.witbooking.backoffice.extra.v1.BookableRefExtra';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.Rate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.extra.v1.Rate.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.Rate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.Rate.displayName = 'proto.witbooking.backoffice.extra.v1.Rate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RatePercentage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RatePercentage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RatePercentage.displayName = 'proto.witbooking.backoffice.extra.v1.RatePercentage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RateConstant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RateConstant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RateConstant.displayName = 'proto.witbooking.backoffice.extra.v1.RateConstant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RateFormula = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RateFormula, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RateFormula.displayName = 'proto.witbooking.backoffice.extra.v1.RateFormula';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RateShared = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RateShared, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RateShared.displayName = 'proto.witbooking.backoffice.extra.v1.RateShared';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RateOwn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RateOwn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RateOwn.displayName = 'proto.witbooking.backoffice.extra.v1.RateOwn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.UnlockCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.UnlockCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.UnlockCode.displayName = 'proto.witbooking.backoffice.extra.v1.UnlockCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.MinStayDuration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.MinStayDuration.displayName = 'proto.witbooking.backoffice.extra.v1.MinStayDuration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.MaxStayDuration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.MaxStayDuration.displayName = 'proto.witbooking.backoffice.extra.v1.MaxStayDuration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.SimpleDuration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.SimpleDuration.displayName = 'proto.witbooking.backoffice.extra.v1.SimpleDuration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DateWindow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.DateWindow.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DateWindow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DateWindow.displayName = 'proto.witbooking.backoffice.extra.v1.DateWindow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.DateWindowPeriod.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DateWindowPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DateWindowPeriod.displayName = 'proto.witbooking.backoffice.extra.v1.DateWindowPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.displayName = 'proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.extra.v1.RestrictionValue.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionValue.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionValueConstant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionValueConstant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionValueShared, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionValueShared.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionValueShared';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueOwn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionValueOwn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionValueOwn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.Restrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.Restrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.Restrictions.displayName = 'proto.witbooking.backoffice.extra.v1.Restrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionAvailability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionAvailability.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionAvailability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionBlockage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionBlockage.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionBlockage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionMinStay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionMinStay.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionMinStay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionMaxStay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionMaxStay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionMinNotice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionMinNotice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionCode.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.displayName = 'proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.UnlockCodes.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.UnlockCodes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.UnlockCodes.displayName = 'proto.witbooking.backoffice.extra.v1.UnlockCodes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.Multimedia = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.Multimedia.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.Multimedia, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.Multimedia.displayName = 'proto.witbooking.backoffice.extra.v1.Multimedia';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.Translation.displayName = 'proto.witbooking.backoffice.extra.v1.Translation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.extra.v1.InventoryTickerList.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.extra.v1.InventoryTickerList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.extra.v1.InventoryTickerList.displayName = 'proto.witbooking.backoffice.extra.v1.InventoryTickerList';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.GetExtrasRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetExtrasRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.GetExtrasRequest;
  return proto.witbooking.backoffice.extra.v1.GetExtrasRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.GetExtrasRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetExtrasRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.GetExtrasResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    extrasList: jspb.Message.toObjectList(msg.getExtrasList(),
    proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtrasResponse}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.GetExtrasResponse;
  return proto.witbooking.backoffice.extra.v1.GetExtrasResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtrasResponse}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.deserializeBinaryFromReader);
      msg.addExtras(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.GetExtrasResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtrasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ExtraLegacyEntity extras = 1;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity>}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.prototype.getExtrasList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity>} value
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtrasResponse} returns this
*/
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.prototype.setExtrasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity}
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.prototype.addExtras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtrasResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.GetExtrasResponse.prototype.clearExtrasList = function() {
  return this.setExtrasList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.GetExtraRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtraRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.GetExtraRequest;
  return proto.witbooking.backoffice.extra.v1.GetExtraRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtraRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.GetExtraRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtraRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.GetExtraRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.GetExtraResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtraResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    extra: (f = msg.getExtra()) && proto.witbooking.backoffice.extra.v1.Extra.toObject(includeInstance, f),
    appliesToAgrInventoriesMap: (f = msg.getAppliesToAgrInventoriesMap()) ? f.toObject(includeInstance, proto.witbooking.backoffice.extra.v1.BookableRefInventory.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.GetExtraResponse;
  return proto.witbooking.backoffice.extra.v1.GetExtraResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtraResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.Extra;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Extra.deserializeBinaryFromReader);
      msg.setExtra(value);
      break;
    case 2:
      var value = msg.getAppliesToAgrInventoriesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.backoffice.extra.v1.BookableRefInventory.deserializeBinaryFromReader, "", new proto.witbooking.backoffice.extra.v1.BookableRefInventory());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.GetExtraResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtraResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtra();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.Extra.serializeBinaryToWriter
    );
  }
  f = message.getAppliesToAgrInventoriesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.backoffice.extra.v1.BookableRefInventory.serializeBinaryToWriter);
  }
};


/**
 * optional Extra extra = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.Extra}
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.prototype.getExtra = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.Extra} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.Extra, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.Extra|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtraResponse} returns this
*/
proto.witbooking.backoffice.extra.v1.GetExtraResponse.prototype.setExtra = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtraResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.prototype.clearExtra = function() {
  return this.setExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.prototype.hasExtra = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, BookableRefInventory> applies_to_agr_inventories = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.BookableRefInventory>}
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.prototype.getAppliesToAgrInventoriesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.BookableRefInventory>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.witbooking.backoffice.extra.v1.BookableRefInventory));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.GetExtraResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.GetExtraResponse.prototype.clearAppliesToAgrInventoriesMap = function() {
  this.getAppliesToAgrInventoriesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.CreateExtraRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extra: (f = msg.getExtra()) && proto.witbooking.backoffice.extra.v1.Extra.toObject(includeInstance, f),
    appliesToAgrInventoriesMap: (f = msg.getAppliesToAgrInventoriesMap()) ? f.toObject(includeInstance, proto.witbooking.backoffice.extra.v1.BookableRefList.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.CreateExtraRequest;
  return proto.witbooking.backoffice.extra.v1.CreateExtraRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.Extra;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Extra.deserializeBinaryFromReader);
      msg.setExtra(value);
      break;
    case 2:
      var value = msg.getAppliesToAgrInventoriesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.backoffice.extra.v1.BookableRefList.deserializeBinaryFromReader, "", new proto.witbooking.backoffice.extra.v1.BookableRefList());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.CreateExtraRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtra();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.Extra.serializeBinaryToWriter
    );
  }
  f = message.getAppliesToAgrInventoriesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.backoffice.extra.v1.BookableRefList.serializeBinaryToWriter);
  }
};


/**
 * optional Extra extra = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.Extra}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.prototype.getExtra = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.Extra} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.Extra, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.Extra|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} returns this
*/
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.prototype.setExtra = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.prototype.clearExtra = function() {
  return this.setExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.prototype.hasExtra = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, BookableRefList> applies_to_agr_inventories = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.BookableRefList>}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.prototype.getAppliesToAgrInventoriesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.BookableRefList>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.witbooking.backoffice.extra.v1.BookableRefList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.CreateExtraRequest.prototype.clearAppliesToAgrInventoriesMap = function() {
  this.getAppliesToAgrInventoriesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.CreateExtraResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataMap: (f = msg.getDataMap()) ? f.toObject(includeInstance, proto.witbooking.backoffice.extra.v1.ExtraList.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.CreateExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.CreateExtraResponse;
  return proto.witbooking.backoffice.extra.v1.CreateExtraResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.CreateExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.backoffice.extra.v1.ExtraList.deserializeBinaryFromReader, "", new proto.witbooking.backoffice.extra.v1.ExtraList());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.CreateExtraResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.backoffice.extra.v1.ExtraList.serializeBinaryToWriter);
  }
};


/**
 * map<string, ExtraList> data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.ExtraList>}
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse.prototype.getDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.ExtraList>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.backoffice.extra.v1.ExtraList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.CreateExtraResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.CreateExtraResponse.prototype.clearDataMap = function() {
  this.getDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    extra: (f = msg.getExtra()) && proto.witbooking.backoffice.extra.v1.Extra.toObject(includeInstance, f),
    appliesToAgrInventoriesMap: (f = msg.getAppliesToAgrInventoriesMap()) ? f.toObject(includeInstance, proto.witbooking.backoffice.extra.v1.BookableRefList.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.UpdateExtraRequest;
  return proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraId(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.extra.v1.Extra;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Extra.deserializeBinaryFromReader);
      msg.setExtra(value);
      break;
    case 3:
      var value = msg.getAppliesToAgrInventoriesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.backoffice.extra.v1.BookableRefList.deserializeBinaryFromReader, "", new proto.witbooking.backoffice.extra.v1.BookableRefList());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExtra();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.extra.v1.Extra.serializeBinaryToWriter
    );
  }
  f = message.getAppliesToAgrInventoriesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.backoffice.extra.v1.BookableRefList.serializeBinaryToWriter);
  }
};


/**
 * optional string extra_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.getExtraId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.setExtraId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Extra extra = 2;
 * @return {?proto.witbooking.backoffice.extra.v1.Extra}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.getExtra = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.Extra} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.Extra, 2));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.Extra|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} returns this
*/
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.setExtra = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.clearExtra = function() {
  return this.setExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.hasExtra = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * map<string, BookableRefList> applies_to_agr_inventories = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.BookableRefList>}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.getAppliesToAgrInventoriesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.BookableRefList>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.witbooking.backoffice.extra.v1.BookableRefList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraRequest.prototype.clearAppliesToAgrInventoriesMap = function() {
  this.getAppliesToAgrInventoriesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataMap: (f = msg.getDataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.UpdateExtraResponse;
  return proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
};


/**
 * map<string, int32> data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.prototype.getDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.UpdateExtraResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.prototype.clearDataMap = function() {
  this.getDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest;
  return proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    extrasList: jspb.Message.toObjectList(msg.getExtrasList(),
    proto.witbooking.backoffice.extra.v1.Extra.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse;
  return proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.Extra;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Extra.deserializeBinaryFromReader);
      msg.addExtras(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtrasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.Extra.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Extra extras = 1;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.Extra>}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.prototype.getExtrasList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.Extra>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.Extra, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.Extra>} value
 * @return {!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse} returns this
*/
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.prototype.setExtrasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.Extra=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.Extra}
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.prototype.addExtras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.extra.v1.Extra, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.prototype.clearExtrasList = function() {
  return this.setExtrasList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DeleteExtraRequest;
  return proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DeleteExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DeleteExtraResponse;
  return proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DeleteExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    beforeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    afterId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.ReorderExtraRequest;
  return proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeforeId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfterId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeforeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAfterId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string before_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.prototype.getBeforeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.prototype.setBeforeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string after_id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.prototype.getAfterId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraRequest.prototype.setAfterId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.ReorderExtraResponse;
  return proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraResponse}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    beforeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    afterId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest;
  return proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeforeId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfterId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBeforeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAfterId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string extra_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.prototype.getExtraId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.prototype.setExtraId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string before_id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.prototype.getBeforeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.prototype.setBeforeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string after_id = 3;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.prototype.getAfterId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest.prototype.setAfterId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse;
  return proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.ExtraList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.ExtraList.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.ExtraList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.ExtraList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ExtraList.toObject = function(includeInstance, msg) {
  var f, obj = {
    extrasList: jspb.Message.toObjectList(msg.getExtrasList(),
    proto.witbooking.backoffice.extra.v1.Extra.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraList}
 */
proto.witbooking.backoffice.extra.v1.ExtraList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.ExtraList;
  return proto.witbooking.backoffice.extra.v1.ExtraList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.ExtraList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraList}
 */
proto.witbooking.backoffice.extra.v1.ExtraList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.Extra;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Extra.deserializeBinaryFromReader);
      msg.addExtras(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ExtraList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.ExtraList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.ExtraList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ExtraList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtrasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.Extra.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Extra extras = 1;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.Extra>}
 */
proto.witbooking.backoffice.extra.v1.ExtraList.prototype.getExtrasList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.Extra>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.Extra, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.Extra>} value
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraList} returns this
*/
proto.witbooking.backoffice.extra.v1.ExtraList.prototype.setExtrasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.Extra=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.Extra}
 */
proto.witbooking.backoffice.extra.v1.ExtraList.prototype.addExtras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.extra.v1.Extra, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraList} returns this
 */
proto.witbooking.backoffice.extra.v1.ExtraList.prototype.clearExtrasList = function() {
  return this.setExtrasList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.witbooking.backoffice.extra.v1.FilterExtra.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.FilterExtrasRequest;
  return proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.FilterExtra;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.FilterExtra.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.FilterExtra.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FilterExtra filters = 1;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.FilterExtra>}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.FilterExtra>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.FilterExtra, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.FilterExtra>} value
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} returns this
*/
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtra=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtra}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.extra.v1.FilterExtra, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.FilterExtra.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtra} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtra}
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.FilterExtra;
  return proto.witbooking.backoffice.extra.v1.FilterExtra.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtra} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtra}
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.FilterExtra.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtra} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtra} returns this
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtra} returns this
 */
proto.witbooking.backoffice.extra.v1.FilterExtra.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    extrasList: jspb.Message.toObjectList(msg.getExtrasList(),
    proto.witbooking.backoffice.extra.v1.Extra.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.FilterExtrasResponse;
  return proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.Extra;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Extra.deserializeBinaryFromReader);
      msg.addExtras(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtrasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.Extra.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Extra extras = 1;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.Extra>}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.prototype.getExtrasList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.Extra>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.Extra, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.Extra>} value
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse} returns this
*/
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.prototype.setExtrasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.Extra=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.Extra}
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.prototype.addExtras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.extra.v1.Extra, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.prototype.clearExtrasList = function() {
  return this.setExtrasList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest;
  return proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileData: msg.getFileData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse;
  return proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes file_data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.prototype.getFileData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes file_data = 1;
 * This is a type-conversion wrapper around `getFileData()`
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.prototype.getFileData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileData()));
};


/**
 * optional bytes file_data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileData()`
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.prototype.getFileData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.prototype.setFileData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest;
  return proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string extra_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.prototype.getExtraId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest.prototype.setExtraId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileData: msg.getFileData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse;
  return proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes file_data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.prototype.getFileData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes file_data = 1;
 * This is a type-conversion wrapper around `getFileData()`
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.prototype.getFileData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileData()));
};


/**
 * optional bytes file_data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileData()`
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.prototype.getFileData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.prototype.setFileData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    content: msg.getContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest;
  return proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes content = 1;
 * @return {!(string|Uint8Array)}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.prototype.getContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes content = 1;
 * This is a type-conversion wrapper around `getContent()`
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.prototype.getContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getContent()));
};


/**
 * optional bytes content = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContent()`
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.prototype.getContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataMap: (f = msg.getDataMap()) ? f.toObject(includeInstance, proto.witbooking.backoffice.extra.v1.InventoryTickerList.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse;
  return proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.backoffice.extra.v1.InventoryTickerList.deserializeBinaryFromReader, "", new proto.witbooking.backoffice.extra.v1.InventoryTickerList());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.backoffice.extra.v1.InventoryTickerList.serializeBinaryToWriter);
  }
};


/**
 * map<string, InventoryTickerList> data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.InventoryTickerList>}
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.prototype.getDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.backoffice.extra.v1.InventoryTickerList>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.backoffice.extra.v1.InventoryTickerList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse} returns this
 */
proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.prototype.clearDataMap = function() {
  this.getDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest;
  return proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string extra_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.prototype.getExtraId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest} returns this
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest.prototype.setExtraId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse;
  return proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    legacyId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity}
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity;
  return proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity}
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegacyId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLegacyId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity} returns this
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 legacy_id = 2;
 * @return {number}
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.prototype.getLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity} returns this
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.prototype.setLegacyId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity} returns this
 */
proto.witbooking.backoffice.extra.v1.ExtraLegacyEntity.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.Extra.repeatedFields_ = [6,7,9,10,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.Extra.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.Extra} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Extra.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 3, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    visible: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    appliesToList: jspb.Message.toObjectList(msg.getAppliesToList(),
    proto.witbooking.backoffice.extra.v1.BookableRef.toObject, includeInstance),
    notificationEmailsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    rate: (f = msg.getRate()) && proto.witbooking.backoffice.extra.v1.Rate.toObject(includeInstance, f),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.extra.v1.Translation.toObject, includeInstance),
    multimediaList: jspb.Message.toObjectList(msg.getMultimediaList(),
    proto.witbooking.backoffice.extra.v1.Multimedia.toObject, includeInstance),
    restrictions: (f = msg.getRestrictions()) && proto.witbooking.backoffice.extra.v1.Restrictions.toObject(includeInstance, f),
    lockType: jspb.Message.getFieldWithDefault(msg, 12, 0),
    stayDaysFilterType: jspb.Message.getFieldWithDefault(msg, 13, 0),
    appliesToGuestsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    variant: jspb.Message.getFieldWithDefault(msg, 15, 0),
    maxBookableUnits: jspb.Message.getFieldWithDefault(msg, 16, 0),
    parentPropertyTicker: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra}
 */
proto.witbooking.backoffice.extra.v1.Extra.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.Extra;
  return proto.witbooking.backoffice.extra.v1.Extra.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.Extra} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra}
 */
proto.witbooking.backoffice.extra.v1.Extra.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.backoffice.extra.v1.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.extra.v1.BookableRef;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.BookableRef.deserializeBinaryFromReader);
      msg.addAppliesTo(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addNotificationEmails(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.extra.v1.Rate;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Rate.deserializeBinaryFromReader);
      msg.setRate(value);
      break;
    case 9:
      var value = new proto.witbooking.backoffice.extra.v1.Translation;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 10:
      var value = new proto.witbooking.backoffice.extra.v1.Multimedia;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Multimedia.deserializeBinaryFromReader);
      msg.addMultimedia(value);
      break;
    case 11:
      var value = new proto.witbooking.backoffice.extra.v1.Restrictions;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    case 12:
      var value = /** @type {!proto.witbooking.backoffice.extra.v1.LockType} */ (reader.readEnum());
      msg.setLockType(value);
      break;
    case 13:
      var value = /** @type {!proto.witbooking.backoffice.extra.v1.StayDaysFilterType} */ (reader.readEnum());
      msg.setStayDaysFilterType(value);
      break;
    case 14:
      var value = /** @type {!Array<!proto.witbooking.backoffice.extra.v1.GuestType>} */ (reader.readPackedEnum());
      msg.setAppliesToGuestsList(value);
      break;
    case 15:
      var value = /** @type {!proto.witbooking.backoffice.extra.v1.Variant} */ (reader.readEnum());
      msg.setVariant(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxBookableUnits(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentPropertyTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.Extra.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.Extra} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Extra.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAppliesToList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.witbooking.backoffice.extra.v1.BookableRef.serializeBinaryToWriter
    );
  }
  f = message.getNotificationEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getRate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.extra.v1.Rate.serializeBinaryToWriter
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.witbooking.backoffice.extra.v1.Translation.serializeBinaryToWriter
    );
  }
  f = message.getMultimediaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.witbooking.backoffice.extra.v1.Multimedia.serializeBinaryToWriter
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.witbooking.backoffice.extra.v1.Restrictions.serializeBinaryToWriter
    );
  }
  f = message.getLockType();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getStayDaysFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getAppliesToGuestsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      14,
      f
    );
  }
  f = message.getVariant();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getMaxBookableUnits();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getParentPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional Type type = 1;
 * @return {!proto.witbooking.backoffice.extra.v1.Type}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.extra.v1.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.Type} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ticker = 3;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool active = 4;
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool visible = 5;
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated BookableRef applies_to = 6;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.BookableRef>}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getAppliesToList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.BookableRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.BookableRef, 6));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.BookableRef>} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
*/
proto.witbooking.backoffice.extra.v1.Extra.prototype.setAppliesToList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.addAppliesTo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.witbooking.backoffice.extra.v1.BookableRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.clearAppliesToList = function() {
  return this.setAppliesToList([]);
};


/**
 * repeated string notification_emails = 7;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getNotificationEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setNotificationEmailsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.addNotificationEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.clearNotificationEmailsList = function() {
  return this.setNotificationEmailsList([]);
};


/**
 * optional Rate rate = 8;
 * @return {?proto.witbooking.backoffice.extra.v1.Rate}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getRate = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.Rate} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.Rate, 8));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.Rate|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
*/
proto.witbooking.backoffice.extra.v1.Extra.prototype.setRate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.clearRate = function() {
  return this.setRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.hasRate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated Translation translations = 9;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.Translation>}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.Translation, 9));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.Translation>} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
*/
proto.witbooking.backoffice.extra.v1.Extra.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.Translation}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.witbooking.backoffice.extra.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * repeated Multimedia multimedia = 10;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.Multimedia>}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getMultimediaList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.Multimedia>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.Multimedia, 10));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.Multimedia>} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
*/
proto.witbooking.backoffice.extra.v1.Extra.prototype.setMultimediaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.Multimedia=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.Multimedia}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.addMultimedia = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.witbooking.backoffice.extra.v1.Multimedia, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.clearMultimediaList = function() {
  return this.setMultimediaList([]);
};


/**
 * optional Restrictions restrictions = 11;
 * @return {?proto.witbooking.backoffice.extra.v1.Restrictions}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getRestrictions = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.Restrictions} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.Restrictions, 11));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.Restrictions|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
*/
proto.witbooking.backoffice.extra.v1.Extra.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional LockType lock_type = 12;
 * @return {!proto.witbooking.backoffice.extra.v1.LockType}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getLockType = function() {
  return /** @type {!proto.witbooking.backoffice.extra.v1.LockType} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.LockType} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setLockType = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional StayDaysFilterType stay_days_filter_type = 13;
 * @return {!proto.witbooking.backoffice.extra.v1.StayDaysFilterType}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getStayDaysFilterType = function() {
  return /** @type {!proto.witbooking.backoffice.extra.v1.StayDaysFilterType} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.StayDaysFilterType} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setStayDaysFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * repeated GuestType applies_to_guests = 14;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.GuestType>}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getAppliesToGuestsList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.extra.v1.GuestType>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.GuestType>} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setAppliesToGuestsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.GuestType} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.addAppliesToGuests = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.clearAppliesToGuestsList = function() {
  return this.setAppliesToGuestsList([]);
};


/**
 * optional Variant variant = 15;
 * @return {!proto.witbooking.backoffice.extra.v1.Variant}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getVariant = function() {
  return /** @type {!proto.witbooking.backoffice.extra.v1.Variant} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.Variant} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setVariant = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional int32 max_bookable_units = 16;
 * @return {number}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getMaxBookableUnits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setMaxBookableUnits = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string parent_property_ticker = 17;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.getParentPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Extra} returns this
 */
proto.witbooking.backoffice.extra.v1.Extra.prototype.setParentPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.BookableRefList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.toObject = function(includeInstance, msg) {
  var f, obj = {
    bookableRefsList: jspb.Message.toObjectList(msg.getBookableRefsList(),
    proto.witbooking.backoffice.extra.v1.BookableRef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefList}
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.BookableRefList;
  return proto.witbooking.backoffice.extra.v1.BookableRefList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefList}
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.BookableRef;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.BookableRef.deserializeBinaryFromReader);
      msg.addBookableRefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.BookableRefList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBookableRefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.BookableRef.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BookableRef bookable_refs = 1;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.BookableRef>}
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.prototype.getBookableRefsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.BookableRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.BookableRef, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.BookableRef>} value
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefList} returns this
*/
proto.witbooking.backoffice.extra.v1.BookableRefList.prototype.setBookableRefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef}
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.prototype.addBookableRefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.extra.v1.BookableRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefList} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefList.prototype.clearBookableRefsList = function() {
  return this.setBookableRefsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefInventoryList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.toObject = function(includeInstance, msg) {
  var f, obj = {
    bookableRefsList: jspb.Message.toObjectList(msg.getBookableRefsList(),
    proto.witbooking.backoffice.extra.v1.BookableRefInventory.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventoryList}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.BookableRefInventoryList;
  return proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefInventoryList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventoryList}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.BookableRefInventory;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.BookableRefInventory.deserializeBinaryFromReader);
      msg.addBookableRefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefInventoryList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBookableRefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.BookableRefInventory.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BookableRefInventory bookable_refs = 1;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.BookableRefInventory>}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.prototype.getBookableRefsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.BookableRefInventory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.BookableRefInventory, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.BookableRefInventory>} value
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventoryList} returns this
*/
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.prototype.setBookableRefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefInventory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventory}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.prototype.addBookableRefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.extra.v1.BookableRefInventory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventoryList} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventoryList.prototype.clearBookableRefsList = function() {
  return this.setBookableRefsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.BookableRef.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.RefTypeCase = {
  REF_TYPE_NOT_SET: 0,
  INVENTORY: 1,
  PROMO: 2,
  EXTRA: 3
};

/**
 * @return {proto.witbooking.backoffice.extra.v1.BookableRef.RefTypeCase}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.getRefTypeCase = function() {
  return /** @type {proto.witbooking.backoffice.extra.v1.BookableRef.RefTypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.extra.v1.BookableRef.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.BookableRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventory: (f = msg.getInventory()) && proto.witbooking.backoffice.extra.v1.BookableRefInventory.toObject(includeInstance, f),
    promo: (f = msg.getPromo()) && proto.witbooking.backoffice.extra.v1.BookableRefPromo.toObject(includeInstance, f),
    extra: (f = msg.getExtra()) && proto.witbooking.backoffice.extra.v1.BookableRefExtra.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.BookableRef;
  return proto.witbooking.backoffice.extra.v1.BookableRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.BookableRefInventory;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.BookableRefInventory.deserializeBinaryFromReader);
      msg.setInventory(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.extra.v1.BookableRefPromo;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.BookableRefPromo.deserializeBinaryFromReader);
      msg.setPromo(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.extra.v1.BookableRefExtra;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.BookableRefExtra.deserializeBinaryFromReader);
      msg.setExtra(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.BookableRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventory();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.BookableRefInventory.serializeBinaryToWriter
    );
  }
  f = message.getPromo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.extra.v1.BookableRefPromo.serializeBinaryToWriter
    );
  }
  f = message.getExtra();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.extra.v1.BookableRefExtra.serializeBinaryToWriter
    );
  }
};


/**
 * optional BookableRefInventory inventory = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.BookableRefInventory}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.getInventory = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.BookableRefInventory} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.BookableRefInventory, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.BookableRefInventory|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef} returns this
*/
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.setInventory = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.extra.v1.BookableRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.clearInventory = function() {
  return this.setInventory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.hasInventory = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BookableRefPromo promo = 2;
 * @return {?proto.witbooking.backoffice.extra.v1.BookableRefPromo}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.getPromo = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.BookableRefPromo} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.BookableRefPromo, 2));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.BookableRefPromo|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef} returns this
*/
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.setPromo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.extra.v1.BookableRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.clearPromo = function() {
  return this.setPromo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.hasPromo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional BookableRefExtra extra = 3;
 * @return {?proto.witbooking.backoffice.extra.v1.BookableRefExtra}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.getExtra = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.BookableRefExtra} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.BookableRefExtra, 3));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.BookableRefExtra|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef} returns this
*/
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.setExtra = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.backoffice.extra.v1.BookableRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRef} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.clearExtra = function() {
  return this.setExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.BookableRef.prototype.hasExtra = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.BookableRefInventory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefInventory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.toObject = function(includeInstance, msg) {
  var f, obj = {
    tickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventory}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.BookableRefInventory;
  return proto.witbooking.backoffice.extra.v1.BookableRefInventory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefInventory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventory}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.BookableRefInventory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefInventory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.prototype.getTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventory} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.prototype.setTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventory} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.prototype.addTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefInventory} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefInventory.prototype.clearTickersList = function() {
  return this.setTickersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.BookableRefPromo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefPromo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.toObject = function(includeInstance, msg) {
  var f, obj = {
    tickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefPromo}
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.BookableRefPromo;
  return proto.witbooking.backoffice.extra.v1.BookableRefPromo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefPromo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefPromo}
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.BookableRefPromo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefPromo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.prototype.getTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefPromo} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.prototype.setTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefPromo} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.prototype.addTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefPromo} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefPromo.prototype.clearTickersList = function() {
  return this.setTickersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.BookableRefExtra.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefExtra} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.toObject = function(includeInstance, msg) {
  var f, obj = {
    tickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefExtra}
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.BookableRefExtra;
  return proto.witbooking.backoffice.extra.v1.BookableRefExtra.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefExtra} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefExtra}
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.BookableRefExtra.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.BookableRefExtra} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.prototype.getTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefExtra} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.prototype.setTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefExtra} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.prototype.addTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.BookableRefExtra} returns this
 */
proto.witbooking.backoffice.extra.v1.BookableRefExtra.prototype.clearTickersList = function() {
  return this.setTickersList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.Rate.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.Rate.RateTypeCase = {
  RATE_TYPE_NOT_SET: 0,
  PERCENTAGE: 1,
  CONSTANT: 2,
  FORMULA: 3,
  OWN: 4,
  SHARED: 5
};

/**
 * @return {proto.witbooking.backoffice.extra.v1.Rate.RateTypeCase}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.getRateTypeCase = function() {
  return /** @type {proto.witbooking.backoffice.extra.v1.Rate.RateTypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.extra.v1.Rate.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.Rate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.Rate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Rate.toObject = function(includeInstance, msg) {
  var f, obj = {
    percentage: (f = msg.getPercentage()) && proto.witbooking.backoffice.extra.v1.RatePercentage.toObject(includeInstance, f),
    constant: (f = msg.getConstant()) && proto.witbooking.backoffice.extra.v1.RateConstant.toObject(includeInstance, f),
    formula: (f = msg.getFormula()) && proto.witbooking.backoffice.extra.v1.RateFormula.toObject(includeInstance, f),
    own: (f = msg.getOwn()) && proto.witbooking.backoffice.extra.v1.RateOwn.toObject(includeInstance, f),
    shared: (f = msg.getShared()) && proto.witbooking.backoffice.extra.v1.RateShared.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.Rate}
 */
proto.witbooking.backoffice.extra.v1.Rate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.Rate;
  return proto.witbooking.backoffice.extra.v1.Rate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.Rate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.Rate}
 */
proto.witbooking.backoffice.extra.v1.Rate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RatePercentage;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RatePercentage.deserializeBinaryFromReader);
      msg.setPercentage(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.extra.v1.RateConstant;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RateConstant.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.extra.v1.RateFormula;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RateFormula.deserializeBinaryFromReader);
      msg.setFormula(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.extra.v1.RateOwn;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RateOwn.deserializeBinaryFromReader);
      msg.setOwn(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.extra.v1.RateShared;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RateShared.deserializeBinaryFromReader);
      msg.setShared(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.Rate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.Rate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Rate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercentage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RatePercentage.serializeBinaryToWriter
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.extra.v1.RateConstant.serializeBinaryToWriter
    );
  }
  f = message.getFormula();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.extra.v1.RateFormula.serializeBinaryToWriter
    );
  }
  f = message.getOwn();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.extra.v1.RateOwn.serializeBinaryToWriter
    );
  }
  f = message.getShared();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.extra.v1.RateShared.serializeBinaryToWriter
    );
  }
};


/**
 * optional RatePercentage percentage = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RatePercentage}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.getPercentage = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RatePercentage} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RatePercentage, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RatePercentage|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
*/
proto.witbooking.backoffice.extra.v1.Rate.prototype.setPercentage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.extra.v1.Rate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.clearPercentage = function() {
  return this.setPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.hasPercentage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RateConstant constant = 2;
 * @return {?proto.witbooking.backoffice.extra.v1.RateConstant}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RateConstant} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RateConstant, 2));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RateConstant|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
*/
proto.witbooking.backoffice.extra.v1.Rate.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.extra.v1.Rate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RateFormula formula = 3;
 * @return {?proto.witbooking.backoffice.extra.v1.RateFormula}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.getFormula = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RateFormula} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RateFormula, 3));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RateFormula|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
*/
proto.witbooking.backoffice.extra.v1.Rate.prototype.setFormula = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.backoffice.extra.v1.Rate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.clearFormula = function() {
  return this.setFormula(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.hasFormula = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RateOwn own = 4;
 * @return {?proto.witbooking.backoffice.extra.v1.RateOwn}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.getOwn = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RateOwn} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RateOwn, 4));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RateOwn|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
*/
proto.witbooking.backoffice.extra.v1.Rate.prototype.setOwn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.witbooking.backoffice.extra.v1.Rate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.clearOwn = function() {
  return this.setOwn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.hasOwn = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RateShared shared = 5;
 * @return {?proto.witbooking.backoffice.extra.v1.RateShared}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.getShared = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RateShared} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RateShared, 5));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RateShared|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
*/
proto.witbooking.backoffice.extra.v1.Rate.prototype.setShared = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.witbooking.backoffice.extra.v1.Rate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Rate} returns this
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.clearShared = function() {
  return this.setShared(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Rate.prototype.hasShared = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RatePercentage.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RatePercentage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RatePercentage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RatePercentage.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RatePercentage}
 */
proto.witbooking.backoffice.extra.v1.RatePercentage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RatePercentage;
  return proto.witbooking.backoffice.extra.v1.RatePercentage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RatePercentage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RatePercentage}
 */
proto.witbooking.backoffice.extra.v1.RatePercentage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RatePercentage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RatePercentage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RatePercentage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RatePercentage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.extra.v1.RatePercentage.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.extra.v1.RatePercentage} returns this
 */
proto.witbooking.backoffice.extra.v1.RatePercentage.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RateConstant.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RateConstant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RateConstant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RateConstant.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RateConstant}
 */
proto.witbooking.backoffice.extra.v1.RateConstant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RateConstant;
  return proto.witbooking.backoffice.extra.v1.RateConstant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RateConstant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RateConstant}
 */
proto.witbooking.backoffice.extra.v1.RateConstant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RateConstant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RateConstant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RateConstant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RateConstant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.extra.v1.RateConstant.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.extra.v1.RateConstant} returns this
 */
proto.witbooking.backoffice.extra.v1.RateConstant.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RateFormula.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RateFormula.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RateFormula} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RateFormula.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RateFormula}
 */
proto.witbooking.backoffice.extra.v1.RateFormula.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RateFormula;
  return proto.witbooking.backoffice.extra.v1.RateFormula.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RateFormula} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RateFormula}
 */
proto.witbooking.backoffice.extra.v1.RateFormula.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RateFormula.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RateFormula.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RateFormula} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RateFormula.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.RateFormula.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.RateFormula} returns this
 */
proto.witbooking.backoffice.extra.v1.RateFormula.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RateShared.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RateShared.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RateShared} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RateShared.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RateShared}
 */
proto.witbooking.backoffice.extra.v1.RateShared.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RateShared;
  return proto.witbooking.backoffice.extra.v1.RateShared.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RateShared} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RateShared}
 */
proto.witbooking.backoffice.extra.v1.RateShared.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RateShared.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RateShared.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RateShared} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RateShared.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.RateShared.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.RateShared} returns this
 */
proto.witbooking.backoffice.extra.v1.RateShared.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RateOwn.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RateOwn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RateOwn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RateOwn.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RateOwn}
 */
proto.witbooking.backoffice.extra.v1.RateOwn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RateOwn;
  return proto.witbooking.backoffice.extra.v1.RateOwn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RateOwn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RateOwn}
 */
proto.witbooking.backoffice.extra.v1.RateOwn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RateOwn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RateOwn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RateOwn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RateOwn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.UnlockCode.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.UnlockCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.UnlockCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.UnlockCode.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.UnlockCode}
 */
proto.witbooking.backoffice.extra.v1.UnlockCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.UnlockCode;
  return proto.witbooking.backoffice.extra.v1.UnlockCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.UnlockCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.UnlockCode}
 */
proto.witbooking.backoffice.extra.v1.UnlockCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.UnlockCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.UnlockCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.UnlockCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.UnlockCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.UnlockCode.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.UnlockCode} returns this
 */
proto.witbooking.backoffice.extra.v1.UnlockCode.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.MinStayDuration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.MinStayDuration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.MinStayDuration}
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.MinStayDuration;
  return proto.witbooking.backoffice.extra.v1.MinStayDuration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.MinStayDuration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.MinStayDuration}
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.MinStayDuration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.MinStayDuration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.extra.v1.MinStayDuration} returns this
 */
proto.witbooking.backoffice.extra.v1.MinStayDuration.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.MaxStayDuration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.MaxStayDuration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.MaxStayDuration}
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.MaxStayDuration;
  return proto.witbooking.backoffice.extra.v1.MaxStayDuration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.MaxStayDuration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.MaxStayDuration}
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.MaxStayDuration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.MaxStayDuration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.extra.v1.MaxStayDuration} returns this
 */
proto.witbooking.backoffice.extra.v1.MaxStayDuration.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.SimpleDuration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.SimpleDuration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.SimpleDuration}
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.SimpleDuration;
  return proto.witbooking.backoffice.extra.v1.SimpleDuration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.SimpleDuration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.SimpleDuration}
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.SimpleDuration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.SimpleDuration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.extra.v1.SimpleDuration} returns this
 */
proto.witbooking.backoffice.extra.v1.SimpleDuration.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.DateWindow.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DateWindow.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DateWindow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DateWindow.toObject = function(includeInstance, msg) {
  var f, obj = {
    isOpen: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    periodList: jspb.Message.toObjectList(msg.getPeriodList(),
    proto.witbooking.backoffice.extra.v1.DateWindowPeriod.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindow}
 */
proto.witbooking.backoffice.extra.v1.DateWindow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DateWindow;
  return proto.witbooking.backoffice.extra.v1.DateWindow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindow}
 */
proto.witbooking.backoffice.extra.v1.DateWindow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOpen(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.extra.v1.DateWindowPeriod;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.DateWindowPeriod.deserializeBinaryFromReader);
      msg.addPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DateWindow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DateWindow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DateWindow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsOpen();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPeriodList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.extra.v1.DateWindowPeriod.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool is_open = 1;
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.DateWindow.prototype.getIsOpen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindow} returns this
 */
proto.witbooking.backoffice.extra.v1.DateWindow.prototype.setIsOpen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated DateWindowPeriod period = 2;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.DateWindowPeriod>}
 */
proto.witbooking.backoffice.extra.v1.DateWindow.prototype.getPeriodList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.DateWindowPeriod>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.DateWindowPeriod, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.DateWindowPeriod>} value
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindow} returns this
*/
proto.witbooking.backoffice.extra.v1.DateWindow.prototype.setPeriodList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod}
 */
proto.witbooking.backoffice.extra.v1.DateWindow.prototype.addPeriod = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.extra.v1.DateWindowPeriod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindow} returns this
 */
proto.witbooking.backoffice.extra.v1.DateWindow.prototype.clearPeriodList = function() {
  return this.setPeriodList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DateWindowPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateRange: (f = msg.getDateRange()) && proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.toObject(includeInstance, f),
    daysList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DateWindowPeriod;
  return proto.witbooking.backoffice.extra.v1.DateWindowPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    case 2:
      var value = /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (reader.readPackedEnum());
      msg.setDaysList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DateWindowPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.serializeBinaryToWriter
    );
  }
  f = message.getDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
};


/**
 * optional DateWindowPeriodDateRange date_range = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.getDateRange = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod} returns this
*/
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod} returns this
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated witbooking.backoffice.common.DayOfWeek days = 2;
 * @return {!Array<!proto.witbooking.backoffice.common.DayOfWeek>}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.getDaysList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} value
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod} returns this
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.setDaysList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.common.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod} returns this
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.addDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriod} returns this
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriod.prototype.clearDaysList = function() {
  return this.setDaysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange;
  return proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange} returns this
*/
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange} returns this
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange} returns this
*/
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange} returns this
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.DateWindowPeriodDateRange.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.ValueCase = {
  VALUE_NOT_SET: 0,
  CONSTANT: 1,
  SHARED: 2,
  OWN: 3
};

/**
 * @return {proto.witbooking.backoffice.extra.v1.RestrictionValue.ValueCase}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.extra.v1.RestrictionValue.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.extra.v1.RestrictionValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    constant: (f = msg.getConstant()) && proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.toObject(includeInstance, f),
    shared: (f = msg.getShared()) && proto.witbooking.backoffice.extra.v1.RestrictionValueShared.toObject(includeInstance, f),
    own: (f = msg.getOwn()) && proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
  return proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValueConstant;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValueShared;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValueShared.deserializeBinaryFromReader);
      msg.setShared(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValueOwn;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.deserializeBinaryFromReader);
      msg.setOwn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.serializeBinaryToWriter
    );
  }
  f = message.getShared();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValueShared.serializeBinaryToWriter
    );
  }
  f = message.getOwn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValueConstant constant = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValueConstant}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValueConstant|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValue} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.extra.v1.RestrictionValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValue} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RestrictionValueShared shared = 2;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValueShared}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.getShared = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValueShared} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValueShared, 2));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValueShared|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValue} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.setShared = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.extra.v1.RestrictionValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValue} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.clearShared = function() {
  return this.setShared(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.hasShared = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RestrictionValueOwn own = 3;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValueOwn}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.getOwn = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValueOwn} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValueOwn, 3));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValueOwn|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValue} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.setOwn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.backoffice.extra.v1.RestrictionValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValue} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.clearOwn = function() {
  return this.setOwn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValue.prototype.hasOwn = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_ = [[1,2,3,4,5,6]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.ValueCase = {
  VALUE_NOT_SET: 0,
  INT_VALUE: 1,
  MIN_STAY_DURATION: 2,
  MAX_STAY_DURATION: 3,
  SIMPLE_DURATION: 4,
  DATE_WINDOW: 5,
  UNLOCK_CODES: 6
};

/**
 * @return {proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.ValueCase}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.toObject = function(includeInstance, msg) {
  var f, obj = {
    intValue: jspb.Message.getFieldWithDefault(msg, 1, 0),
    minStayDuration: (f = msg.getMinStayDuration()) && proto.witbooking.backoffice.extra.v1.MinStayDuration.toObject(includeInstance, f),
    maxStayDuration: (f = msg.getMaxStayDuration()) && proto.witbooking.backoffice.extra.v1.MaxStayDuration.toObject(includeInstance, f),
    simpleDuration: (f = msg.getSimpleDuration()) && proto.witbooking.backoffice.extra.v1.SimpleDuration.toObject(includeInstance, f),
    dateWindow: (f = msg.getDateWindow()) && proto.witbooking.backoffice.extra.v1.DateWindow.toObject(includeInstance, f),
    unlockCodes: (f = msg.getUnlockCodes()) && proto.witbooking.backoffice.extra.v1.UnlockCodes.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionValueConstant;
  return proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntValue(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.extra.v1.MinStayDuration;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.MinStayDuration.deserializeBinaryFromReader);
      msg.setMinStayDuration(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.extra.v1.MaxStayDuration;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.MaxStayDuration.deserializeBinaryFromReader);
      msg.setMaxStayDuration(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.extra.v1.SimpleDuration;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.SimpleDuration.deserializeBinaryFromReader);
      msg.setSimpleDuration(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.extra.v1.DateWindow;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.DateWindow.deserializeBinaryFromReader);
      msg.setDateWindow(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.extra.v1.UnlockCodes;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.UnlockCodes.deserializeBinaryFromReader);
      msg.setUnlockCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMinStayDuration();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.extra.v1.MinStayDuration.serializeBinaryToWriter
    );
  }
  f = message.getMaxStayDuration();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.extra.v1.MaxStayDuration.serializeBinaryToWriter
    );
  }
  f = message.getSimpleDuration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.extra.v1.SimpleDuration.serializeBinaryToWriter
    );
  }
  f = message.getDateWindow();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.extra.v1.DateWindow.serializeBinaryToWriter
    );
  }
  f = message.getUnlockCodes();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.backoffice.extra.v1.UnlockCodes.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 int_value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.getIntValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.setIntValue = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.clearIntValue = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.hasIntValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MinStayDuration min_stay_duration = 2;
 * @return {?proto.witbooking.backoffice.extra.v1.MinStayDuration}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.getMinStayDuration = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.MinStayDuration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.MinStayDuration, 2));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.MinStayDuration|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.setMinStayDuration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.clearMinStayDuration = function() {
  return this.setMinStayDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.hasMinStayDuration = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MaxStayDuration max_stay_duration = 3;
 * @return {?proto.witbooking.backoffice.extra.v1.MaxStayDuration}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.getMaxStayDuration = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.MaxStayDuration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.MaxStayDuration, 3));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.MaxStayDuration|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.setMaxStayDuration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.clearMaxStayDuration = function() {
  return this.setMaxStayDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.hasMaxStayDuration = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SimpleDuration simple_duration = 4;
 * @return {?proto.witbooking.backoffice.extra.v1.SimpleDuration}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.getSimpleDuration = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.SimpleDuration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.SimpleDuration, 4));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.SimpleDuration|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.setSimpleDuration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.clearSimpleDuration = function() {
  return this.setSimpleDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.hasSimpleDuration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DateWindow date_window = 5;
 * @return {?proto.witbooking.backoffice.extra.v1.DateWindow}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.getDateWindow = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.DateWindow} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.DateWindow, 5));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.DateWindow|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.setDateWindow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.clearDateWindow = function() {
  return this.setDateWindow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.hasDateWindow = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional UnlockCodes unlock_codes = 6;
 * @return {?proto.witbooking.backoffice.extra.v1.UnlockCodes}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.getUnlockCodes = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.UnlockCodes} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.UnlockCodes, 6));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.UnlockCodes|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.setUnlockCodes = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.clearUnlockCodes = function() {
  return this.setUnlockCodes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueConstant.prototype.hasUnlockCodes = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionValueShared.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueShared} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueShared}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionValueShared;
  return proto.witbooking.backoffice.extra.v1.RestrictionValueShared.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueShared} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueShared}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionValueShared.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueShared} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueShared} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueShared.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueOwn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueOwn}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionValueOwn;
  return proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueOwn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionValueOwn}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionValueOwn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionValueOwn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.Restrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.Restrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Restrictions.toObject = function(includeInstance, msg) {
  var f, obj = {
    availability: (f = msg.getAvailability()) && proto.witbooking.backoffice.extra.v1.RestrictionAvailability.toObject(includeInstance, f),
    blockage: (f = msg.getBlockage()) && proto.witbooking.backoffice.extra.v1.RestrictionBlockage.toObject(includeInstance, f),
    minStay: (f = msg.getMinStay()) && proto.witbooking.backoffice.extra.v1.RestrictionMinStay.toObject(includeInstance, f),
    maxStay: (f = msg.getMaxStay()) && proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.toObject(includeInstance, f),
    minNotice: (f = msg.getMinNotice()) && proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.toObject(includeInstance, f),
    maxNotice: (f = msg.getMaxNotice()) && proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.toObject(includeInstance, f),
    code: (f = msg.getCode()) && proto.witbooking.backoffice.extra.v1.RestrictionCode.toObject(includeInstance, f),
    bookingWindow: (f = msg.getBookingWindow()) && proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.toObject(includeInstance, f),
    travelWindow: (f = msg.getTravelWindow()) && proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.Restrictions;
  return proto.witbooking.backoffice.extra.v1.Restrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.Restrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionAvailability;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionAvailability.deserializeBinaryFromReader);
      msg.setAvailability(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionBlockage;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionBlockage.deserializeBinaryFromReader);
      msg.setBlockage(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionMinStay;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionMinStay.deserializeBinaryFromReader);
      msg.setMinStay(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionMaxStay;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.deserializeBinaryFromReader);
      msg.setMaxStay(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionMinNotice;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.deserializeBinaryFromReader);
      msg.setMinNotice(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.deserializeBinaryFromReader);
      msg.setMaxNotice(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionCode;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionCode.deserializeBinaryFromReader);
      msg.setCode(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.deserializeBinaryFromReader);
      msg.setBookingWindow(value);
      break;
    case 9:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.deserializeBinaryFromReader);
      msg.setTravelWindow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.Restrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.Restrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Restrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailability();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionAvailability.serializeBinaryToWriter
    );
  }
  f = message.getBlockage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionBlockage.serializeBinaryToWriter
    );
  }
  f = message.getMinStay();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionMinStay.serializeBinaryToWriter
    );
  }
  f = message.getMaxStay();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.serializeBinaryToWriter
    );
  }
  f = message.getMinNotice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.serializeBinaryToWriter
    );
  }
  f = message.getMaxNotice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.serializeBinaryToWriter
    );
  }
  f = message.getCode();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionCode.serializeBinaryToWriter
    );
  }
  f = message.getBookingWindow();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.serializeBinaryToWriter
    );
  }
  f = message.getTravelWindow();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionAvailability availability = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionAvailability}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getAvailability = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionAvailability} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionAvailability, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionAvailability|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setAvailability = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearAvailability = function() {
  return this.setAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasAvailability = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RestrictionBlockage blockage = 2;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionBlockage}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getBlockage = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionBlockage} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionBlockage, 2));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionBlockage|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setBlockage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearBlockage = function() {
  return this.setBlockage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasBlockage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RestrictionMinStay min_stay = 3;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionMinStay}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getMinStay = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionMinStay} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionMinStay, 3));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionMinStay|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setMinStay = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearMinStay = function() {
  return this.setMinStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasMinStay = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RestrictionMaxStay max_stay = 4;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionMaxStay}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getMaxStay = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionMaxStay} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionMaxStay, 4));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionMaxStay|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setMaxStay = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearMaxStay = function() {
  return this.setMaxStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasMaxStay = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RestrictionMinNotice min_notice = 5;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionMinNotice}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getMinNotice = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionMinNotice} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionMinNotice, 5));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionMinNotice|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setMinNotice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearMinNotice = function() {
  return this.setMinNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasMinNotice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RestrictionMaxNotice max_notice = 6;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getMaxNotice = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice, 6));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setMaxNotice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearMaxNotice = function() {
  return this.setMaxNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasMaxNotice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional RestrictionCode code = 7;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionCode}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getCode = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionCode} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionCode, 7));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionCode|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setCode = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearCode = function() {
  return this.setCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasCode = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional RestrictionBookingWindow booking_window = 8;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getBookingWindow = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow, 8));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setBookingWindow = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearBookingWindow = function() {
  return this.setBookingWindow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasBookingWindow = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional RestrictionTravelWindow travel_window = 9;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.getTravelWindow = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow, 9));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.setTravelWindow = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.clearTravelWindow = function() {
  return this.setTravelWindow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.Restrictions.prototype.hasTravelWindow = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionAvailability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionAvailability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionAvailability}
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionAvailability;
  return proto.witbooking.backoffice.extra.v1.RestrictionAvailability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionAvailability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionAvailability}
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionAvailability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionAvailability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionAvailability} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionAvailability} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionAvailability.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionBlockage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionBlockage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionBlockage}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionBlockage;
  return proto.witbooking.backoffice.extra.v1.RestrictionBlockage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionBlockage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionBlockage}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionBlockage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionBlockage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionBlockage} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionBlockage} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBlockage.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionMinStay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMinStay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMinStay}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionMinStay;
  return proto.witbooking.backoffice.extra.v1.RestrictionMinStay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMinStay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMinStay}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionMinStay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMinStay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMinStay} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMinStay} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinStay.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMaxStay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMaxStay}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionMaxStay;
  return proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMaxStay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMaxStay}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMaxStay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMaxStay} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMaxStay} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxStay.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMinNotice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMinNotice}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionMinNotice;
  return proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMinNotice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMinNotice}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMinNotice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMinNotice} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMinNotice} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMinNotice.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice;
  return proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionMaxNotice.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionCode}
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionCode;
  return proto.witbooking.backoffice.extra.v1.RestrictionCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionCode}
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionCode} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionCode.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionCode} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionCode.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow;
  return proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionBookingWindow.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.witbooking.backoffice.extra.v1.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow}
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow;
  return proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow}
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.RestrictionValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue value = 1;
 * @return {?proto.witbooking.backoffice.extra.v1.RestrictionValue}
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.extra.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.extra.v1.RestrictionValue, 1));
};


/**
 * @param {?proto.witbooking.backoffice.extra.v1.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow} returns this
*/
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow} returns this
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.extra.v1.RestrictionTravelWindow.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.UnlockCodes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.UnlockCodes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.toObject = function(includeInstance, msg) {
  var f, obj = {
    codesList: jspb.Message.toObjectList(msg.getCodesList(),
    proto.witbooking.backoffice.extra.v1.UnlockCode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.UnlockCodes}
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.UnlockCodes;
  return proto.witbooking.backoffice.extra.v1.UnlockCodes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.UnlockCodes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.UnlockCodes}
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.extra.v1.UnlockCode;
      reader.readMessage(value,proto.witbooking.backoffice.extra.v1.UnlockCode.deserializeBinaryFromReader);
      msg.addCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.UnlockCodes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.UnlockCodes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.extra.v1.UnlockCode.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UnlockCode codes = 1;
 * @return {!Array<!proto.witbooking.backoffice.extra.v1.UnlockCode>}
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.prototype.getCodesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.extra.v1.UnlockCode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.extra.v1.UnlockCode, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.extra.v1.UnlockCode>} value
 * @return {!proto.witbooking.backoffice.extra.v1.UnlockCodes} returns this
*/
proto.witbooking.backoffice.extra.v1.UnlockCodes.prototype.setCodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.UnlockCode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.UnlockCode}
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.prototype.addCodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.extra.v1.UnlockCode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.UnlockCodes} returns this
 */
proto.witbooking.backoffice.extra.v1.UnlockCodes.prototype.clearCodesList = function() {
  return this.setCodesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.Multimedia.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.Multimedia.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.Multimedia} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Multimedia.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    url: jspb.Message.getFieldWithDefault(msg, 3, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    witbooking_backoffice_common_common_pb.MultimediaTranslation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.Multimedia}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.Multimedia;
  return proto.witbooking.backoffice.extra.v1.Multimedia.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.Multimedia} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.Multimedia}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = new witbooking_backoffice_common_common_pb.MultimediaTranslation;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.MultimediaTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.Multimedia.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.Multimedia} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Multimedia.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      witbooking_backoffice_common_common_pb.MultimediaTranslation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated witbooking.backoffice.common.MultimediaTranslation translations = 4;
 * @return {!Array<!proto.witbooking.backoffice.common.MultimediaTranslation>}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.common.MultimediaTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, witbooking_backoffice_common_common_pb.MultimediaTranslation, 4));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.MultimediaTranslation>} value
 * @return {!proto.witbooking.backoffice.extra.v1.Multimedia} returns this
*/
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.backoffice.common.MultimediaTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.common.MultimediaTranslation}
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.backoffice.common.MultimediaTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.extra.v1.Multimedia.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.Translation}
 */
proto.witbooking.backoffice.extra.v1.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.Translation;
  return proto.witbooking.backoffice.extra.v1.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.Translation}
 */
proto.witbooking.backoffice.extra.v1.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Translation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Translation} returns this
 */
proto.witbooking.backoffice.extra.v1.Translation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Translation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Translation} returns this
 */
proto.witbooking.backoffice.extra.v1.Translation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.extra.v1.Translation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.extra.v1.Translation} returns this
 */
proto.witbooking.backoffice.extra.v1.Translation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.extra.v1.InventoryTickerList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.extra.v1.InventoryTickerList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.toObject = function(includeInstance, msg) {
  var f, obj = {
    tickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.extra.v1.InventoryTickerList}
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.extra.v1.InventoryTickerList;
  return proto.witbooking.backoffice.extra.v1.InventoryTickerList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.extra.v1.InventoryTickerList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.extra.v1.InventoryTickerList}
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.extra.v1.InventoryTickerList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.extra.v1.InventoryTickerList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.prototype.getTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.extra.v1.InventoryTickerList} returns this
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.prototype.setTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.extra.v1.InventoryTickerList} returns this
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.prototype.addTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.extra.v1.InventoryTickerList} returns this
 */
proto.witbooking.backoffice.extra.v1.InventoryTickerList.prototype.clearTickersList = function() {
  return this.setTickersList([]);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.FilterExtraUse = {
  OWN: 0,
  SHARED: 1
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.GuestType = {
  ADULT: 0,
  CHILD: 1,
  BABY: 2,
  TEENAGER: 3,
  SENIOR: 4
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.Variant = {
  PER_DAY: 0,
  MANDATORY: 1,
  PER_DAY_MANDATORY: 2,
  SPECIFIC_DATE: 3,
  UNKNOWN: 4
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.Type = {
  ROOM: 0,
  PERSON: 1,
  UNIT: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.LockType = {
  DAY: 0,
  STAY: 1
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.extra.v1.StayDaysFilterType = {
  ALL_STAY_DAYS_EXCEPT_CHECKOUT: 0,
  ALL_STAY_DAYS_EXCEPT_CHECKIN: 1,
  ALL_STAY_DAYS_EXCEPT_CHECKIN_AND_CHECKOUT: 2,
  ONLY_CHECKIN: 3,
  ONLY_CHECKOUT: 4,
  ALL_STAY_DAYS: 5,
  IGNORE: 6
};

goog.object.extend(exports, proto.witbooking.backoffice.extra.v1);
